import React, { useEffect, useRef, useState } from "react";
import "./calendar.css";
import Left from "../../../../../picture/play-left.png";
import Right from "../../../../../picture/play-right.png";

const normalizeYear = (yy) => {
  if (!yy) return new Date().getFullYear();
  const y = Number(yy);
  if (y > 1900) return y;
  return y < 50 ? 2000 + y : 1900 + y;
};

const formatDateYY = (date) => {
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const yyyy = String(date.getFullYear()); // 4 cifre
  return `${dd}.${mm}.${yyyy}`;
};

function Calendar({
  isOpen = true,
  handleClose = () => {},
  handleClickDate,
  selectedDate,
  disableFuture = false,
  disablePast = false,
}) {
  const [currentCalendarDate, setCurrentCalendarDate] = useState(new Date());
  const [editingYear, setEditingYear] = useState(false);
  const [yearInput, setYearInput] = useState("");
  const calendarRef = useRef(null);

  useEffect(() => {
    if (selectedDate) {
      const parts = selectedDate.replace(/\.$/, "").split(".");
      if (parts.length >= 3) {
        const [dd, mm, yy] = parts;
        const fullYear = normalizeYear(yy);
        setCurrentCalendarDate(new Date(fullYear, Number(mm) - 1, Number(dd)));
      }
    }
  }, [selectedDate]);

  const handlePreviousMonth = () => {
    const newDate = new Date(currentCalendarDate);
    newDate.setMonth(newDate.getMonth() - 1);
    setCurrentCalendarDate(newDate);
  };

  const handleNextMonth = () => {
    const newDate = new Date(currentCalendarDate);
    newDate.setMonth(newDate.getMonth() + 1);
    setCurrentCalendarDate(newDate);
  };

  const handleYearClick = () => {
    setYearInput(String(currentCalendarDate.getFullYear()));
    setEditingYear(true);
  };

  const handleYearConfirm = () => {
    const y = parseInt(yearInput);
    if (!isNaN(y) && y > 1900 && y < 2100) {
      const newDate = new Date(currentCalendarDate);
      newDate.setFullYear(y);
      setCurrentCalendarDate(newDate);
    }
    setEditingYear(false);
  };

  const handleYearKeyDown = (e) => {
    if (e.key === "Enter") handleYearConfirm();
    if (e.key === "Escape") setEditingYear(false);
  };

  const generateCalendarDays = () => {
    const year = currentCalendarDate.getFullYear();
    const month = currentCalendarDate.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    let startingDayOfWeek = firstDay.getDay();
    startingDayOfWeek = startingDayOfWeek === 0 ? 6 : startingDayOfWeek - 1;

    const days = [];
    for (let i = 0; i < startingDayOfWeek; i++) days.push(null);
    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(year, month, day);
      const dateString = formatDateYY(date);
      const isToday = new Date().toDateString() === date.toDateString();
      const currentDate = new Date().setHours(0, 0, 0, 0);
      const isPast = date < currentDate;
      const isFuture = date > currentDate;
      days.push({ day, dateString, isToday, isPast, isFuture });
    }
    return days;
  };

  const handleClick = (dateString) => {
    handleClickDate(dateString);
    handleClose();
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        handleClose();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  if (!isOpen) return null;

  return (
    <div
      className="evidencije-calendar"
      ref={calendarRef}
      style={{ position: "absolute", top: "30px", zIndex: 100 }}
    >
      <div className="evidencije-calendar-header">
        <img src={Left} alt="Previous" onClick={handlePreviousMonth} />
        <span className="evidencije-calendar-month">
          {currentCalendarDate
            .toLocaleDateString("sr-Latn-RS", { month: "long" })
            .toUpperCase()}
          <span style={{ margin: "0 5px" }}>-</span>
          {editingYear ? (
            <input
              autoFocus
              value={yearInput}
              onChange={(e) => setYearInput(e.target.value)}
              onBlur={handleYearConfirm}
              onKeyDown={handleYearKeyDown}
              style={{
                width: "52px",
                fontSize: "inherit",
                fontWeight: "inherit",
                textAlign: "center",
                background: "transparent",
                border: "none",
                borderBottom: "1px solid white",
                color: "inherit",
                outline: "none",
                padding: "0",
              }}
            />
          ) : (
            <span
              onClick={handleYearClick}
              title="Klikni da promeniš godinu"
              style={{
                cursor: "pointer",
                textDecoration: "underline",
                textUnderlineOffset: "3px",
              }}
            >
              {currentCalendarDate.getFullYear()}
            </span>
          )}
        </span>
        <img src={Right} alt="Next" onClick={handleNextMonth} />
      </div>

      <div className="evidencije-calendar-main">
        {["P", "U", "S", "Č", "P", "S", "N"].map((d, i) => (
          <span key={i} className="evidencije-calendar-header-day">
            {d}
          </span>
        ))}
        {generateCalendarDays().map((dayData, index) => {
          if (!dayData)
            return (
              <div
                key={index}
                className="evidencije-calendar-main-item-empty"
              ></div>
            );
          const isDisabledDay =
            (disableFuture && dayData.isFuture) ||
            (disablePast && dayData.isPast);
          return (
            <div
              key={index}
              className={`evidencije-calendar-main-item ${dayData.dateString === selectedDate ? "today" : ""}`}
              onClick={
                isDisabledDay
                  ? undefined
                  : () => handleClick(dayData.dateString)
              }
              style={{
                opacity: isDisabledDay ? 0.2 : 1,
                flexDirection: "column",
                justifyContent: "flex-end",
              }}
            >
              <div className="evidencije-calendar-main-item-day">
                {String(dayData.day).padStart(2, "0")}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Calendar;
